import { PublicLayout } from "@/components/layout/PublicLayout";
import { ShieldCheck, Lock, FileCheck2, Users } from "lucide-react";

const values = [
  {
    icon: ShieldCheck,
    title: "Trust first",
    body: "We keep the process simple and transparent. You always know what you're submitting and why.",
  },
  {
    icon: Lock,
    title: "Private by default",
    body: "Your details are stored in a private database, accessible only to the business owner.",
  },
  {
    icon: FileCheck2,
    title: "Clear consent",
    body: "Consent is recorded with a timestamp and the exact language you agreed to — nothing hidden.",
  },
  {
    icon: Users,
    title: "Built for one relationship",
    body: "DeviceLox is a focused intake tool for a single business and its customers.",
  },
];

export default function About() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-testid="about-page">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">
              About DeviceLox
            </p>
            <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
              A straightforward way to register your device.
            </h1>
            <p className="mt-6 leading-relaxed text-slate-600">
              DeviceLox is a small, purpose-built tool that lets customers
              register a device and keep an accurate record on file. It captures
              the essentials — your contact details, the device, and your
              consent — and nothing more.
            </p>
            <p className="mt-4 leading-relaxed text-slate-600">
              We intentionally keep the scope narrow. DeviceLox is not a device
              control platform and does not lock, track, or manage your devices.
              It simply provides a clean, compliant registration process backed
              by clear records.
            </p>
          </div>
          <div className="overflow-hidden rounded-md border border-slate-200 shadow-lg">
            <img
              src="https://images.pexels.com/photos/38482455/pexels-photo-38482455.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Security and trust concept"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div className="mt-20 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-md border border-slate-200 bg-white p-6 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-md"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-slate-900 text-white">
                <v.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-display text-base font-semibold tracking-tight text-slate-900">
                {v.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
